import { render } from "./sectionResident.vue?vue&type=template&id=62de412c&scoped=true"
import script from "./sectionResident.vue?vue&type=script&lang=js"
export * from "./sectionResident.vue?vue&type=script&lang=js"

import "./sectionResident.vue?vue&type=style&index=0&id=62de412c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62de412c"]])

export default __exports__